import { useContext } from 'react'
import { HeaderTheme } from '../../../utils/types/appTypes'
import Locations from '../../components/locations'
import CommonHeader from '../../components/common-header'
import './locationSelection.scss'
import { LOCATIONS_ROUTE, LOGIN_ROUTE } from '../../../utils/constants/Helpers'
import { AppContext } from '../../../providers/context/App'
import { ManageAppointmentButton } from 'views/components/confirmed-appointment/manage-appointment-button'
import Link from 'utils/navigation/CustomLink'

const LocationSelector = () => {
  const { appMasterData, userLogout } = useContext(AppContext)
  return (
    <>
      <CommonHeader theme={HeaderTheme.ORANGE} />
      <div className="location-header">
        <h2>Select a Shop </h2>
        {appMasterData.isLoggedIn && <ManageAppointmentButton />}
        {!appMasterData.isLoggedIn ? (
          <p>
            Have an account?{' '}
            <Link to={`${LOGIN_ROUTE}/from${LOCATIONS_ROUTE}`}>Sign In</Link>
          </p>
        ) : (
          <p>
            <span // NOSONAR
              className="link underline"
              onClick={() => userLogout()}
              onKeyDown={() => userLogout()}
            >
              Log Out
            </span>
          </p>
        )}
      </div>
      <div className="location-container">
        <Locations />
      </div>
    </>
  )
}

export default LocationSelector
